var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cross-circle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.05,3.84a12,12,0,1,0,12,12A12,12,0,0,0,16.05,3.84Zm0,22.28A10.28,10.28,0,1,1,26.33,15.84,10.28,10.28,0,0,1,16.05,26.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20.55 12.42 19.43 11.3 16.06 14.68 12.67 11.29 11.55 12.41 14.94 15.8 11.56 19.18 12.68 20.29 16.06 16.91 19.42 20.28 20.54 19.16 17.18 15.8 20.55 12.42"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircle);
export default __webpack_public_path__ + "static/media/cross-circle.3cac83d4.svg";
export { ForwardRef as ReactComponent };